<script setup>
import { setUri } from '@/mixins/Commons.js';

const props = defineProps({
    mainColor: {
        type: String,
        default: 'blue',
    },
    data: {
        type: Object,
        default: () => {},
    },
    color: {
        type: String,
        default: '',
    },
    themeColor: {
        type: String,
        default: '',
    },
    center: {
        type: Boolean,
        default: false,
    },
});

const parsedLink = setUri({
    uri: props?.data?.data?.link?.[0]?.url,
});
</script>

<template>
    <div
        class="FeaturedContent"
        :class="['is-' + color, { 'is-centered': center }]"
    >
        <div class="Page__right is-l">
            <div
                class="FeaturedContent__wrap relative rounded-2xl p-8 text-white md:rounded-4xl"
                :class="[
                    'bg-dark-' + mainColor,
                    {
                        '!text-white': mainColor == 'blue',
                    },
                ]"
            >
                <template v-if="data.data.featuredContentTitle">
                    <h3
                        class="FeaturedContent__title h3 mb-8 pr-8"
                        :class="[
                            'text-light-' + mainColor,
                            {
                                '!text-white': mainColor == 'indigo',
                            },
                        ]"
                        v-html="data.data.featuredContentTitle"
                    />
                </template>
                <template v-if="data.data.featuredContentText">
                    <div
                        class="FeaturedContent__text Wysiwyg mb-8 whitespace-normal"
                        v-html="data.data.featuredContentText"
                    />
                </template>
                <template v-if="parsedLink">
                    <div class="FeaturedContent__bottom flex justify-end">
                        <a
                            v-if="data.data?.link?.[0]?.type === 'verbb\\hyper\\links\\Url' || data.data?.link?.[0]?.type === 'verbb\\hyper\\links\\Email'"
                            class="block whitespace-nowrap"
                            :href="data.data?.link[0].url"
                            target="_blank"
                        >
                            <Btn
                                :text="data.data.link[0].text"
                                size="small"
                                class="w-full"
                                :class="[
                                    'bg-light-' + mainColor,
                                    'text-dark-' + mainColor,
                                    {
                                        '!text-dark-indigo': mainColor == 'indigo',
                                        '!bg-white': mainColor == 'indigo',
                                    },
                                ]"
                            />
                        </a>
                        <router-link
                            v-else-if="parsedLink"
                            class="whitespace-nowrap"
                            :to="parsedLink"
                        >
                            <Btn
                                :text="data.data.link[0].text"
                                size="small"
                                class="w-full"
                                :class="[
                                    'bg-light-' + mainColor,
                                    'text-dark-' + mainColor,
                                    {
                                        '!text-dark-indigo': mainColor == 'indigo',
                                        '!bg-white': mainColor == 'indigo',
                                    },
                                ]"
                            />
                        </router-link>
                    </div>
                </template>

                <div
                    v-if="data.data.iconPickerCharacters"
                    class="FeaturedContent__icon absolute -right-4 -top-4 flex size-12 shrink-0 items-center justify-center rounded-full bg-white svg:h-3/4 svg:w-auto md:size-15 xl:size-20"
                    :class="['text-dark-' + mainColor]"
                    v-html="data.data.iconPickerCharacters.inline"
                />
            </div>
        </div>
    </div>
</template>
